import { useMemo } from 'react';
import { XAxisProps } from 'recharts';
import {
  DEFAULT_BAR_WIDTH,
  DEFAULT_X_AXIS_CONFIG,
  X_AXIS_DEFAULT_HEIGHT,
  X_AXIS_ROTATED_HEIGHT,
} from '../../constants/utils';
import calculateCartesianGridWidth from '../calculateCartesianGridWidth';
import { ChartMode } from '../../types';

interface IArgs {
  numItems: number;
  chartWidth: number;
  barSize: number;
  chartMode: ChartMode;
}

const useXAxisSettings = ({
  numItems,
  chartWidth,
  barSize,
  chartMode,
}: IArgs): Partial<XAxisProps> & { shouldRotateXAxis: boolean } => {
  const shouldRotateXAxis = useMemo(() => {
    if (chartMode === ChartMode.Compact) {
      return false;
    }
    const cartesianGridWidth = calculateCartesianGridWidth(chartWidth);
    const barContainerWidth = Math.floor(cartesianGridWidth / numItems);
    return barSize + 30 >= barContainerWidth && barSize >= DEFAULT_BAR_WIDTH;
  }, [barSize, numItems, chartWidth, chartMode]);

  const height = shouldRotateXAxis
    ? X_AXIS_ROTATED_HEIGHT // Center label and add padding to prevent cutoff
    : X_AXIS_DEFAULT_HEIGHT;

  return {
    tickSize: DEFAULT_X_AXIS_CONFIG.tickSize,
    // KBT-1373 display all labels in expanded view
    interval: 0,
    height,
    shouldRotateXAxis,
  };
};

export default useXAxisSettings;
